import { useEffect } from "react";
import { useStatusContext } from "/app/src/contexts/hooks/useStatusContext";
import { hooks } from "front-chat-sdk";

/**
 * FrontChat component initializes the front chat interface.
 * @returns {null} This component renders nothing.
 */
export default function FrontChat() {
  const { installType } = useStatusContext();
  const { useFrontChatBoot } = hooks;
  const chatId = "6be6909068c4e9a2f14caa52538555d4";
  const { frontChat, initialize, isInitialized } = useFrontChatBoot(
    document.body,
  );
  useEffect(() => {
    if (!initialize || isInitialized || installType !== "cloud") return;
    initialize({ chatId });
  }, [installType, isInitialized, initialize, chatId, frontChat]);
  return null;
}
